import { render, staticRenderFns } from "./ShareOptionsOperationsDetailsTable.vue?vue&type=template&id=97f50aae&scoped=true&"
import script from "./ShareOptionsOperationsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./ShareOptionsOperationsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShareOptionsOperationsDetailsTable.vue?vue&type=style&index=0&id=97f50aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f50aae",
  null
  
)

export default component.exports